<div [hidden]="isSectionHidden$ | async">
  <div class="pb-3 buttons" *ngIf="props.editableSection">
    <ng-container *ngIf="isEditing$ | async; else notEditing">
      <apm-icon
        class="me-2"
        size="md"
        [isButton]="true"
        (iconClick)="calculate()"
        icon="aa_refresh"
        matTooltip="{{ '444784' | apmTranslate }}"
      ></apm-icon>
      <apm-icon
        size="md"
        [isButton]="true"
        (iconClick)="cancel()"
        icon="aa_cancel"
        matTooltip="{{ '444763' | apmTranslate }}"
      ></apm-icon>
    </ng-container>
  </div>
  <ng-container #fieldComponent></ng-container>
</div>

<ng-template #notEditing>
  @if (hasDatasheetMoreDetailsPermission && props.partialLoads) {
    <apm-icon
      class="me-2"
      size="md"
      [isButton]="true"
      (iconClick)="downloadXls()"
      icon="a_xls"
      matTooltip="{{ '448885' | apmTranslate }}"
    ></apm-icon>
  }

  <apm-icon
    class="me-2"
    size="md"
    [isButton]="true"
    (iconClick)="edit()"
    icon="aa_edit"
    matTooltip="{{ '444765' | apmTranslate }}"
  ></apm-icon>

  <ng-container *ngIf="{ somethingEdited: somethingEdited$ | async } as edited">
    <apm-icon
      class="me-2"
      size="md"
      [isButton]="true"
      [disabled]="!edited.somethingEdited"
      (iconClick)="save()"
      icon="aa_confirm"
      matTooltip="{{ '444682' | apmTranslate }}"
    ></apm-icon>
    <apm-icon
      size="md"
      [isButton]="true"
      [disabled]="!edited.somethingEdited"
      (iconClick)="revert()"
      icon="aa_cancel"
      matTooltip="{{ '444763' | apmTranslate }}"
    ></apm-icon>
  </ng-container>
</ng-template>
